import { type KnownLocale } from "nvent-web/i18n";
import { type DropdownOption } from "nvent-web/types/DropdownOption";
import { type Option } from "nvent-web/types/Option";

export const createOption = (
  option: Option,
  locale: KnownLocale
): DropdownOption => {
  const { id, name } = option;

  return {
    title: name[locale],
    key: id,
  };
};
